import { apiClient } from "@/programs/services/ApiClientV2.js";
import URLPattern from "url-pattern";
import { API } from "@/programs/types";

export const restfulCreate =
  <Params, Response, Payload>(pattern: URLPattern) =>
  async (
    params: Params,
    payload: Payload,
  ): Promise<API.PostResponse<Response>> => {
    const url = pattern.stringify(params);
    const { data } = await apiClient.post<API.PostResponse<Response>>(
      url,
      payload,
    );
    return data;
  };

export const restfulShow =
  <Params, ResponseData, QueryParams = void>(pattern: URLPattern) =>
  async (
    params: Params,
    query?: QueryParams,
  ): Promise<API.GetResponse<ResponseData>> => {
    const url = pattern.stringify(params);
    const { data } = await apiClient.get<API.GetResponse<ResponseData>>(url, {
      params: query,
    });
    return data;
  };

export const restfulUpdate =
  <Params, ResponseData, Payload>(pattern: URLPattern) =>
  async (
    params: Params,
    payload: Payload,
  ): Promise<API.PatchResponse<ResponseData>> => {
    const url = pattern.stringify(params);
    const { data } = await apiClient.patch<API.PatchResponse<ResponseData>>(
      url,
      payload,
    );
    return data;
  };

export const restfulDelete =
  <Params, ResponseData = "">(pattern: URLPattern) =>
  async (params: Params): Promise<API.DeleteResponse<ResponseData>> => {
    const url = pattern.stringify(params);
    const { data } =
      await apiClient.delete<API.DeleteResponse<ResponseData>>(url);
    return data;
  };

export const restfulShowPaginated =
  <URLParams, ResponseData>(pattern: URLPattern) =>
  async (
    urlParams: URLParams,
    pagination: API.PaginationQueryParams,
  ): Promise<API.GetPaginatedResponse<ResponseData>> => {
    const url = pattern.stringify(urlParams);
    const { data } = await apiClient.get<
      API.GetPaginatedResponse<ResponseData>
    >(url, {
      params: {
        ...pagination,
      },
    });
    return data;
  };

export const restfulSearchableShowPaginated =
  <URLParams, ResponseData>(pattern: URLPattern) =>
  async (
    urlParams: URLParams,
    pagination: API.PaginationQueryParams,
    search?: object,
  ): Promise<API.GetPaginatedResponse<ResponseData>> => {
    const url = pattern.stringify(urlParams);
    const { data } = await apiClient.get<
      API.GetPaginatedResponse<ResponseData>
    >(url, {
      params: {
        ...pagination,
        ...(search || {}),
      },
    });
    return data;
  };

export const restfulUpdateForm =
  <Params, ResponseData, Payload>(pattern: URLPattern) =>
  async (
    params: Params,
    payload: Payload,
  ): Promise<API.PatchResponse<ResponseData>> => {
    const url = pattern.stringify(params);
    const { data } = await apiClient.patchForm<API.PatchResponse<ResponseData>>(
      url,
      payload,
    );
    return data;
  };

export const restfulCreateForm =
  <Params, ResponseData, Payload>(pattern: URLPattern) =>
  async (
    params: Params,
    payload: Payload,
  ): Promise<API.PostResponse<ResponseData>> => {
    const url = pattern.stringify(params);
    const { data } = await apiClient.postForm<API.PostResponse<ResponseData>>(
      url,
      payload,
    );
    return data;
  };
